import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ICreateNewAccountDTO } from 'types/User.types';
import { createNewAccount } from 'services/UserService';

export const useCreateNewAccount = () =>
  useMutation((params: ICreateNewAccountDTO) => createNewAccount(params), {
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    mutationKey: ReactMutationKeys.CREATE_NEW_ACCOUNT,
  });
